module.exports = __webpack_public_path__ + "img/casino.a4e27cce.png";